<script setup lang="ts">
import { useApplicationStore } from "../store/application";
import Popper from "vue3-popper";

defineProps<{
  placement?:
    | "auto"
    | "auto-start"
    | "auto-end"
    | "top"
    | "top-start"
    | "top-end"
    | "bottom"
    | "bottom-start"
    | "bottom-end"
    | "right"
    | "right-start"
    | "right-end"
    | "left"
    | "left-start"
    | "left-end"
    | undefined;
}>();

const applicationStore = useApplicationStore();
</script>
<template>
  <Popper arrow :show="applicationStore.showHelperTooltips" :placement="placement">
    <slot></slot>
    <template #content>
      <div class="whitespace-nowrap text-sm font-bold tracking-normal" role="tooltip">
        <slot name="content"> </slot>
      </div>
    </template>
  </Popper>
</template>
